
<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>

    <smr-stylist-picker 
      *ngIf="stylist"
      [showAllStaff]="true"
      [stylistID]="stylist.getID()"
      [readOnly]="readOnlyStylistPicker"
      [disabled]="isLoading"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-sales"        
    ></smr-stylist-picker>

    <ion-buttons slot="end">
      <ion-button 
        (click)="openSearchLookUpPage()">
        <ion-icon name="search"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>

  <ion-toolbar>  
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      [hideGroupBy]="true"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
  <ion-toolbar class="ion-no-padding">
    <ion-buttons class="tab-group">
      <ion-button [ngClass]="{ 'tab-checked': activeSegment == 'completed' }" class="tab-button" (click)="activeSegment = 'completed'; reloadPage()">Completed</ion-button>
      <ion-button [ngClass]="{ 'tab-checked': activeSegment == 'on-hold' }"  class="tab-button" (click)="activeSegment = 'on-hold'; reloadPage()">On Hold</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ng-container *ngIf="!(isLoading || errorOccurredWhileLoadingSales || errorOccurredWhileLoadingStylistPicker)" style="height: 100%">

    <ion-row style="height: 100%">

      <ion-col style="height: 100%">
        <div [ngSwitch]="activeSegment" style="height: 100%">
          <div *ngSwitchCase="'completed'" style="height: 100%">
            <smr-sale-list
              [sales]="completedSales"
              (saleSelect)="viewReceipt($event)"
              >
            </smr-sale-list>
          </div>
          <div *ngSwitchCase="'on-hold'" style="height: 100%">
            <smr-sale-list
              [isReadOnly]="isReadOnly"
              [sales]="onHoldSales"
              (saleSelect)="editOnHoldSale($event)"
              >
            </smr-sale-list>
          </div>
        </div>
      </ion-col>

    </ion-row>

  </ng-container>


  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingSales || errorOccurredWhileLoadingStylistPicker" (click)="onTapToReload()"></salonmonster-tap-retry>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-row>
      <ion-col size="12" >
        <ion-button 
          color="primary"
          expand="block"
          fill="solid"
          [disabled]="isLoading || errorOccurredWhileLoadingSales || errorOccurredWhileLoadingStylistPicker || isReadOnly"
          (click)="createSale()">
          + New sale
        </ion-button>
      </ion-col>

    </ion-row>
  </ion-toolbar>
</ion-footer>
